import React from 'react';

import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { PdfViewer } from '../../common-components/composed/pdfViewer/PdfViewer';
import { colors, layout } from '../../utils/theme';

import AboutSidebar from './sidebar/AboutSidebar';

const useStyles = makeStyles(() => ({
  container: {
    height: `calc(100% - ${layout.APP_HEADER_HEIGHT}px)`,
    backgroundColor: colors.PURE_WHITE,
    position: 'relative',
    top: `${0.5 * layout.APP_HEADER_HEIGHT}px`,
    overflow: 'hidden',
    width: '100%',
  },
  sidebarContainer: {
    minWidth: layout.ABOUT_SIDEBAR_WIDTH,
    width: layout.ABOUT_SIDEBAR_WIDTH,
    height: '100%',
    position: 'sticky',
    top: 0,
  },
  pdfViewerContainer: {
    height: '100%',
    width: `calc(100% - ${layout.ABOUT_SIDEBAR_WIDTH}px)`,
  },
}));

interface Props {
  pdfName: string;
  pdfUrl: string;
}

const About: React.FC<Props> = ({ pdfName, pdfUrl }) => {
  const classes = useStyles();

  return (
    <Grid container className={classes.container}>
      <Grid item className={classes.sidebarContainer}>
        <AboutSidebar pdfName={pdfName} />
      </Grid>
      <Grid item className={`${classes.pdfViewerContainer} pdf-viewer`}>
        <PdfViewer pdfUrl={pdfUrl} />
      </Grid>
    </Grid>
  );
};
export default About;
